export default __webpack_public_path__ + "static/media/a5aa5eba404c25a6ba9513a2ed46976c.svg";